import axios from 'axios';
import { API_BASE_URL } from '../config/api';

/** Unauthenticated API client (public endpoints). */
export const publicApi = axios.create({
  baseURL: API_BASE_URL,
});

export { API_BASE_URL };
